export default class BaseEnum {
  fieldsMap = {};

  fields() {
    return Object.keys(this.fieldsMap);
  }

  getFieldsMap() {
    return this.fieldsMap;
  }

  createLabelValueList() {
    return this.fields().map((field) => {
      return {
        label: this.getReadable(field),
        value: field,
      };
    });
  }

  getReadable(alias) {
    return this.fieldsMap[alias];
  }

  getColumnWidth(alias) {
    const width = this.getReadable(alias).length * 10;

    return `${width < 150 ? 150 : width}px`;
  }

  static make() {
    return new this;
  }
}